export default __webpack_public_path__ + "static/media/transfer-send-step1.d5b2e253.png";